export * from "./headline.component";
